import { Color, rwd, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const PlansWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const CampaignOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.FullScreenOverlay};
  background-color: ${Color.Grey100};
  overflow: auto;

  ${rwd.greaterThan('xlarge')} {
    left: 232px;
  }
`
